<script>
    import R, {LOADER} from "../lib/requests";
    import user from "../stores/user.js";
    import Alert from "../stores/alerts.js";
    import PointsPanel from "../account/PointsPanel.svelte";
    import PassCard from "../components/PassCard.svelte";

    let points = null;
    let maxPoints = null;
    let progress = 0;

    const showError = () => {
        Alert.warning("This is alert title", "this is the body of the alert");
    }

    const showAlert = () => {
        Alert.alert("This is alert title", "this is the body of the alert");
    }

    const showConfirm = () => {
        Alert.confirm("This is alert title", "this is the body of the alert");
    }

    const load = () => {
        const onSuccess = result => {
            points = result.points;
            maxPoints = result.max;
        }

        const onFailure = err => {
        };

        R.handle(R.member.dashboard, [], onSuccess, onFailure, LOADER.PAGE);
    }
</script>

{#if $user.token}
    <div class="page-header solid">
        <h1>Dashboard</h1>
    </div>
    <div class="page page-padding">
        <div class="mb-5">
            <h1 class="h2 mb-1">{ $user.name }</h1>
            <div class="text-gray fs-5">CARD NUMBER: { $user.code }</div>
        </div>
        <PointsPanel points="{ points }" max="{ maxPoints }"/>
        <PassCard css="mt-5"/>
    </div>
{:else}
    <div class="page welcome-panel">
        <svg viewBox="0 0 960 540" width="100%" height="100%" preserveAspectRatio="xMidYMax slice"
             xmlns="http://www.w3.org/2000/svg" class="graphics circles">
            <g fill="none" stroke="currentColor" stroke-width="100">
                <circle r="234" cx="196" cy="23"></circle>
                <circle r="234" cx="790" cy="491"></circle>
            </g>
        </svg>
        <svg viewBox="0 0 220 192" width="220" height="192" fill="none" class="graphics dots">
            <defs>
                <pattern id="837c3e70-6c3a-44e6-8854-cc48c737b659" x="0" y="0" width="20" height="20"
                         patternUnits="userSpaceOnUse">
                    <rect x="0" y="0" width="4" height="4" fill="currentColor"></rect>
                </pattern>
            </defs>
            <rect width="220" height="192" fill="url(#837c3e70-6c3a-44e6-8854-cc48c737b659)"></rect>
        </svg>
        <div class="welcome-content">
            <div class="h1 line-height-1 mb-4">Enorme Hotels Loyalty</div>
            <div>
                <p>
                    Welcome to <b>Enorme Hotels</b>, where luxury meets loyalty.<br>
                    As a premier hospitality provider, we take pride in offering more than just exquisite accommodations
                    and
                    impeccable service – we offer an experience that rewards you every step of the way.
                </p>
                <p>
                    With our exclusive loyalty system, each time you check into one of our distinguished hotels, you
                    embark on a journey of
                    accumulation, earning points that unlock a world of perks and privileges. Whether you're traveling
                    for
                    business or leisure, our commitment to your satisfaction extends beyond your stay, ensuring that
                    every
                    moment with us is not just memorable, but also rewarding.
                </p>
                <p>
                    Discover the essence of hospitality with Enorme, where your loyalty is cherished and
                    celebrated.
                </p>
            </div>
            <div class="row mt-5">
                <div class="col-xl-5 col-lg-4 col-md-4"></div>
                <div class="col-xl-2 col-lg-4 col-md-4">
                    <button class="btn btn-outline-dark btn-block mb-3" on:click={ user.showSignUp }>
                        Sign Up
                    </button>
                    <button class="btn btn-outline-dark btn-block" on:click={ user.showLogin }>
                        Sign In
                    </button>
                </div>
            </div>
        </div>
    </div>
{/if}

<style>
    .welcome-panel {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        height: calc(100vh - 55px);
        /*color: #888;*/
        /*background: #0f172a;*/
        color: #807f7d;
        background: #000;
        padding: 5rem;
        overflow: hidden;
    }

    .welcome-panel .graphics {
        position: absolute;
        opacity: 0.1;
        color: #ccc;
    }

    .welcome-panel .circles {
        left: 0;
    }

    .welcome-panel .dots {
        top: -100px;
        right: -100px;
    }

    .welcome-panel .welcome-content {
        z-index: 9000;
    }

    .welcome-panel .welcome-content .h1 {
        color: #D4B275;
    }

    @media (max-width: 576px) {
        .welcome-panel {
            padding: 2rem;
        }
    }
</style>